import { useState } from "react";

export const Left = ({children}) => {
    return (
        <div className="left">
            <div>
                <h3 className='schedule-title-header title-header mb-3' style={{color: "#6C6C6C"}}>Scheduling</h3>
                <div className='list-box rounded'>
                    {children}
                </div>
            </div>
        </div>
    )
}